import { isObject, isArray, map, pick, compact } from 'lodash';

const visualProps = [
  'aria-checked',
  'className',
  'path',
  'data-automation',
  'disabled',
  'filled',
  'svgClassName'
];

export const getVisualPropsTree = ({ children, props, ...restProps } = {}) => ({
  childrenProps: getChildrenProps(children || props), // eslint-disable-line no-use-before-define
  ...pick(restProps, visualProps)
});

const getChildrenProps = children => {
  // eslint-disable-line no-use-before-define
  if (isArray(children)) {
    return map(compact(children), child => {
      if (!child.props) {
        return child;
      }

      return getVisualPropsTree(child.props);
    });
  }

  if (isObject(children)) {
    return getVisualPropsTree(children);
  }

  return children;
};
